import createReactClass from "create-react-class";
import React from "react";
export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      necessariesItem: this.props.necessariesItem,
    };
  },
  onError() {
    var updated = this.state.necessariesItem;
    updated.thumbnail_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      necessariesItem: updated,
    });
  },
  render() {
    var timeAgo = this.state.necessariesItem.created_at_time_ago_format;
    var isUnread = this.state.necessariesItem.is_read === false;
    return (
      <li className="notif-2026__item-wrap">
        <a
          href={this.props.necessariesItem.url}
          id="necessaries-item"
          className={"notif-2026__item" + (isUnread ? " notif-2026__item--unread" : "")}
        >
          <div className="notif-2026__row">
            <div className="notif-2026__thumb-wrap">
              <img
                src={this.state.necessariesItem.thumbnail_image_url}
                onError={this.onError}
                className="notif-2026__thumb"
                alt=""
              />
            </div>
            <div className="notif-2026__body">
              <div className="notif-2026__title-row">
                <p
                  className="notif-2026__body-title"
                  dangerouslySetInnerHTML={{
                    __html: this.state.necessariesItem.title,
                  }}
                />
              </div>
              {/* この画面は「まだ対応していないこと」だけが並ぶ場所で、
                  対応すると一覧から消える。並んでいること自体が未対応の印なので、
                  未読の赤丸は出さない（実データでも99.6%が未読で目印にならない） */}
              {/* 日付と「対応する」ボタンを同じ行に並べ、ボタンは右端に置く */}
              <div className="notif-2026__meta">
                <p className="notif-2026__time">{timeAgo}</p>
                <span className="notif-2026__arrow" aria-hidden="true">
                  <span className="notif-2026__action">対応する</span>
                </span>
              </div>
            </div>
          </div>
        </a>
      </li>
    );
  },
});